import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = { class: "table border-top-0" };
const _hoisted_2 = { class: "text-end" };
const _hoisted_3 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_loader = _resolveComponent("g-loader");
    return (_openBlock(), _createElementBlock("div", null, [
        _createElementVNode("table", _hoisted_1, [
            _cache[0] || (_cache[0] = _createElementVNode("thead", null, [
                _createElementVNode("tr", { class: "font-weight-bold" }, [
                    _createElementVNode("td", { class: "border-top-0" }, "Schlüssel"),
                    _createElementVNode("td", { class: "border-top-0 text-end" }, "Aktionen")
                ])
            ], -1)),
            _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.cache, (item) => {
                    return (_openBlock(), _createElementBlock("tr", null, [
                        _createElementVNode("td", null, _toDisplayString(item.name), 1),
                        _createElementVNode("td", _hoisted_2, [
                            _createElementVNode("a", {
                                href: "#",
                                onClick: ($event) => (_ctx.deleteCache($event, item))
                            }, " Leeren ", 8, _hoisted_3)
                        ])
                    ]));
                }), 256))
            ])
        ]),
        (_ctx.isLoading)
            ? (_openBlock(), _createBlock(_component_g_loader, { key: 0 }))
            : _createCommentVNode("", true)
    ]));
}
